import React, { useState, useEffect } from "react";
import "alpinejs";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import helpers from "@src/../js/helpers";
import {GlobalMenuProvider} from "@src/contexts/GlobalMenuProvider";
import {HeaderActionAccount} from "./HeaderActionAccount";
import {HeaderActionCart} from "./HeaderActionCart";
import {HeaderActionSearch} from "./HeaderActionSearch";
import {HeaderActionCurrency} from "./HeaderActionCurrency";
import {HeaderActionWishlist} from "./HeaderActionWishlist";
import { Link } from "@arctheme-components/elements/Link/Link";
import {Button} from "@src/stories/elements/Button/Button";

export const HeaderActions = ({ item_count, settings }) => {
    const isMobile = useMobileBreakpoint(settings.breakpoint);

    const [cartItemCount, setCartItemCount] = useState(0);

    useEffect(() => {

        const fetchCart = async (event) => {

            try {
                const response = await fetch(`/cart.js`);
                const cartData = await response.json();
                const updatedItemCount = cartData.item_count || 0;
                setCartItemCount(updatedItemCount);
            } catch (error) {
                console.error("Error fetching cart:", error);
            }
        };

        document.addEventListener("liquid-ajax-cart:request-end", function(event: any) {
            const {requestState, cart, previousCart, sections} = event.detail;
            fetchCart({ detail: {} });
        });

        fetchCart({ detail: {} });
        // Clean up the event listener when the component is unmounted
        return () => {
            window.removeEventListener('liquid-ajax-cart:request-end', () => {});
        };
    }, []);

    function handleMenuClick() {
        window.dispatchEvent(new CustomEvent('onOpenMenu', {
            detail: { message: 'header-menu' }
        }));
    }

    return (
        <GlobalMenuProvider>
            <div className="flex items-center lg:space-x-[32px] justify-end header-toolbar">

                <Button link={`#footer`} className={`${isMobile ? '!hidden' : ''}`} style="primary" icon="right-arrow-alt" label={`Contact us`} />

                <button onClick={() => handleMenuClick()} className={`${isMobile ? '!hidden' : ''}`}>
                    <span className="text-[28px] icon-menu"></span>
                </button>

                <HeaderActionSearch isMobile={isMobile} settings={settings}/>
                <HeaderActionCurrency isMobile={isMobile} settings={settings}/>
                <HeaderActionWishlist isMobile={isMobile} settings={settings}/>
                {/* <HeaderActionAccount settings={settings} isMobile={isMobile}/> */}
                <HeaderActionCart settings={settings} isMobile={isMobile} cartItemCount={cartItemCount}/>
            </div>
        </GlobalMenuProvider>
    );
};
